import { useEffect } from 'react'

/**
 * Locks `document.body` scroll while `locked` is true, restoring it on unlock/unmount.
 *
 * Used by the self-schedule dialog, which runs in base-ui's `trap-focus` mode so that
 * base-ui's own scroll lock stays off — that lock reserves a scrollbar gutter that
 * leaves a visible strip beside the backdrop.
 */
export const useBodyScrollLock = (locked: boolean): void => {
  useEffect(() => {
    if (!locked) {
      return
    }

    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [locked])
}
